import { render, staticRenderFns } from "./Erp6SaleSignboard.vue?vue&type=template&id=687b96ac&scoped=true&"
import script from "./Erp6SaleSignboard.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleSignboard.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleSignboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Erp6SaleSignboard.vue?vue&type=style&index=1&id=687b96ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b96ac",
  null
  
)

export default component.exports